import React, { useLayoutEffect, useRef } from "react";
import "./webaudio-controls/webaudio-controls-module";
export const WebAudioKeyboard = (props) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        const { current } = ref;
        if (current !== undefined) {
            // @ts-ignore
            current === null || current === void 0 ? void 0 : current.addEventListener("change", (event) => {
                props.onKeyboardChangeNote && (props === null || props === void 0 ? void 0 : props.onKeyboardChangeNote(event.note));
                props.onKeyboardChangeEvent && (props === null || props === void 0 ? void 0 : props.onKeyboardChangeEvent(event));
            });
        }
    }, [ref]);
    return (React.createElement("webaudio-keyboard", { id: (props === null || props === void 0 ? void 0 : props.id) ? props.id : "keyboard", ref: ref, ...props }));
};
